.options {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: 5px;
}

.option {
  color: white;
  background: black;
  font-size: 11px;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;
  border-radius: var(--border-radius);
  padding: 4px 6px 3px;
}

.icon {
  width: 30px;
}

.payment {
  display: flex;
  align-items: flex-start;
  overflow: hidden;
}

.paymentType {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.showStops {
  position: relative;

  &:before {
    display: block;
    position: absolute;
    content: '';
    top: 25px;
    left: 22px;
    width: 1px;
    border-left: 1px dotted #A7A8A9;
    height: calc(100% - 60px);
  }

  & .departure, & .destination {
    position: relative;
  }
}

.alignStart {
  align-items: start;
}

.hasStops {
  padding-left: 56px;
}

.stops {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 56px;
}

.stop {
  position: relative;
  font-size: 15px;

  &:before {
    display: block;
    position: absolute;
    content: '';
    top: 4px;
    left: -37px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #A7A8A9;
  }
}

.label {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  color: rgba(0,0,0,0.8);

  &.gray {
    color: var(--color-black-50);
  }
}
.price {
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left:10px;
}
.price > s {
  color: grey;
  font-weight: 400;
  font-size: 14px;
}
.group {
  display: flex;
  align-items: center;
  overflow: hidden;
}
.groupContent {
  width: 100%;
  overflow: hidden;
}
.groupContentColumn
{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.groupContentMainColumn {
  overflow: hidden;
}
.groupIcon {
  width:44px;
  height:44px;
  margin-right:12px;
}

.charIcon {
  left: 12px;
}